export default __webpack_public_path__ + "9f51527f90e9676070618580a1738dbd.svg";